const hamburger = document.querySelector('.hamburger');
const mobileMenu = document.querySelector('.mobileMenu');
const mobeileMenuHeader = document.querySelector('.mobileMenu-header');
const overlay = document.querySelector('.nav-overlay');

function closeMenu() {
    mobileMenu.classList.remove('active');
    overlay.classList.remove('active');
    mobeileMenuHeader.classList.remove('active');
    document.body.classList.remove('menu-open');
}

hamburger.addEventListener('click', () => {
    mobileMenu.classList.toggle('active');
    overlay.classList.toggle('active');
    mobeileMenuHeader.classList.toggle('active');
    document.body.classList.toggle('menu-open');
});

window.addEventListener('resize', () => {
    // if (window.innerWidth >= 768) {   // match your CSS breakpoint
    mobileMenu.classList.remove('active');
    overlay.classList.remove('active');
    mobeileMenuHeader.classList.remove('active');
    document.body.classList.remove('menu-open');
    // }
});

overlay.addEventListener('click', closeMenu);

const menuItems = document.querySelectorAll('.has-children');


menuItems.forEach(item => {
  const toggleBtn = item.querySelector('.menu-toggle');
  toggleBtn.addEventListener('click', e => {
    e.stopPropagation(); // prevent click bubbling to document
    item.classList.toggle('open');
    toggleBtn.classList.toggle('open');
  });
});

// Close menu when clicking outside
document.addEventListener('click', e => {
  
    menuItems.forEach(item => {
    const toggleBtn = item.querySelector('.menu-toggle');
        if (!item.contains(e.target)) {
      item.classList.remove('open');
      toggleBtn.classList.remove('open');
    }
  });
});